import { GetApp } from "../../App"
import { Block, BlockContainer, BlockFieldInputs, BlockRow } from "../../Components/Block"
import { EditGroup } from "../../Components/EditGroup"
import { Icon, Icons } from "../../Components/Icon"
import { GetShipData } from "./Context"
import { ShipDataAnchorView } from "./AnchorView"
import { ShipDataDeviceView } from "./DeviceView"
import { ShipDataOtherEquipmentView } from "./OtherEquipmentView"
import { ShipDataEquipmentViewProps } from "./Params"

export function ShipDataEquipmentView(_: ShipDataEquipmentViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { editable, edited, onEdited, save, deviceTypes, devices, addDevice, removeDevice, editAnchor, editOtherEquipment } = GetShipData();
  return (
    <EditGroup changed={edited} editable={editable} editableFields={[
      { name: "devices", type: "object", fields: deviceTypes.map((type) => {
        return { name: type, type: "object", array: true, fields: ["id", "deviceType", "manufacturer", "model", "serialNumber", "placeInstallation", "dateInstallation", "specialFeatures"] };
      }) },

      { name: "anchors", type: "object", array: true, fields: ["id", "anchorType", { name: "weight", type: "int" }, "weightUnit", "placeInstallation", "chain", "chainLead", "windlass", "windlassDrive", "windlassManufacturer"] },

      { name: "otherEquipments", type: "object", array: true, fields: ["id", "equipment"] },
    ]} onSave={save}
    >

      {/* Devices – ShipDataDeviceView: electric, nautical, saftey */}
      {deviceTypes.map((type) => (
        <BlockContainer key={type}>
          <Block>
            <BlockRow>
              <h3>{t(`${type}_equipment`)}</h3>
            </BlockRow>
            {(devices[type] || []).map((device, index) => (
              <ShipDataDeviceView data={device} editable={editable} index={index} key={device.id} onEdited={onEdited} removeDevice={() => { removeDevice(type, index); onEdited(); }} devices={type} />
            ))}
            <BlockRow>
              <BlockFieldInputs>
                <button className="button" disabled={!editable} onClick={() => { addDevice(type); onEdited(); }}>
                  <Icon icon={Icons.Plus} /> {t(`${type}_add_device`)}
                </button>
              </BlockFieldInputs>
            </BlockRow>
          </Block>
        </BlockContainer>
      ))}

      {/* Anchors */}
      <BlockContainer>
        <Block>
          <BlockRow>
            <h3>{t("anchors")}</h3>
          </BlockRow>

          {editAnchor.items.map((anchor, index) => (
            <ShipDataAnchorView data={anchor} editable={editable} index={index} key={anchor.id} onEdited={onEdited} removeAnchor={() => { editAnchor.removeAt(index); onEdited(); }} />
          ))}
          <BlockRow>
            <BlockFieldInputs>
              <button className="button" disabled={!editable} onClick={() => { editAnchor.add(); onEdited(); }}>
                <Icon icon={Icons.Plus} /> {t("add_anchor")}
              </button>
            </BlockFieldInputs>
          </BlockRow>
        </Block>
      </BlockContainer>

      {/* Other Equipment – ShipDataOtherEquipmentView */}
      <BlockContainer>
        <Block>
          <BlockRow>
            <h3>{t("other_equipment")}</h3>
          </BlockRow>
          <p>{t("other_equipment_text")}</p>

          {editOtherEquipment.items.map((otherEquipment, index) => (
            <ShipDataOtherEquipmentView data={otherEquipment} editable={editable} index={index} key={otherEquipment.id} onEdited={onEdited} removeEquipment={() => { editOtherEquipment.removeAt(index); onEdited(); }} />
          ))}
          <BlockRow>
            <BlockFieldInputs>
              <button className="button" disabled={!editable} onClick={() => { editOtherEquipment.add(); onEdited(); }}>
                <Icon icon={Icons.Plus} /> {t("add_other_equipment")}
              </button>
            </BlockFieldInputs>
          </BlockRow>
        </Block>
      </BlockContainer>

    </EditGroup>
  );
}
